import { useReceivedProgramRequestsPaginated } from "../api/queries/useRecievedProgramRequests";
import { useOrderedProgramRequestsPaginated } from "../api/queries/useOrderedProgramRequests";

interface UseProgramRequestsCountsResult {
  boughtProgramsCount: number;
  myOrdersCount: number;
  isLoading: boolean;
}

export const useProgramRequestsCounts = (): UseProgramRequestsCountsResult => {
  // Get received programs count (bought programs)
  const { data: receivedPrograms, isLoading: isReceivedLoading } = useReceivedProgramRequestsPaginated({
    limit: 1,
    enabled: true,
  });

  // Get ordered programs count (my orders)
  const { data: orderedPrograms, isLoading: isOrderedLoading } = useOrderedProgramRequestsPaginated({
    limit: 1,
    enabled: true,
  });

  const isLoading = isReceivedLoading || isOrderedLoading;

  const boughtProgramsCount = receivedPrograms?.data?.meta.totalItems || 0;
  const myOrdersCount = orderedPrograms?.data?.meta.totalItems || 0;

  return {
    boughtProgramsCount,
    myOrdersCount,
    isLoading,
  };
};
